// extracted by mini-css-extract-plugin
export default {"wrapper":"DisabledCtaWithTooltip_wrapper__fdq1d"};